var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarSimilarCars = function SvgCarSimilarCars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.305 0h11.39L19 6.059V13H1V6.059L4.305 0Zm.89 1.5L2.5 6.441V11.5h15V6.441L14.805 1.5h-9.61Z",
    fill: "#282830"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9A1.25 1.25 0 1 1 4 9a1.25 1.25 0 0 1 2.5 0ZM15.5 9A1.25 1.25 0 1 1 13 9a1.25 1.25 0 0 1 2.5 0ZM1 11.75h3v4H1v-4ZM16 11.75h3v4h-3v-4Z",
    fill: "#282830"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 6.5H2V5h16v1.5Z",
    fill: "#282830"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.995h2.5v1.51H0v-1.51ZM17.75 3.995h2.5v1.51h-2.5v-1.51Z",
    fill: "#282830"
  })));
};
export default SvgCarSimilarCars;